import Image from "next/image";

import { motion } from "framer-motion";

const imageLoader = require("../loader.js");

const variants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.5,
    },
  },
};

const itemVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
  },
};

export const DesignProcess = () => {
  return (
    <section className={"innerProcessSection"}>
      <div className={"section-wrapper flex-column"}>
        <div className="innerProcessTitle">
          <h1>Meticulous Design Process</h1>
          <p>
            We explore concepts of your product vision, plan, and map out the
            perfect user experience based on research and analysis. We use
            prototyping tools to present the greatest customer journey. And we
            create a product that is likely to avoid the common pitfalls
            experienced by other businesses.
          </p>
        </div>
        <motion.div
          className="innerProcessGraphic"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={variants}
        >
          <motion.div
            className="mobileGraphicBackground"
            variants={itemVariants}
          ></motion.div>

          <motion.div variants={itemVariants}>
            <div className="processGraphicBox graphicBox1">
              <h2>Research & Strategy</h2>
              <p>
                We understand real-world users’ needs and gather insights that
                are the basis for formulating the strategy for your products.
              </p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants}>
            <div className="processGraphicBox graphicBox2">
              <h2>Conceptualization</h2>
              <p>
                Creating visual brand identities and guidelines for digital
                touchpoints.
              </p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants}>
            <div className="processGraphicBox graphicBox3">
              <h2>Detail Design</h2>
              <p>
                Transforming an idea into a user story and designing the assets
                needed for the development of well-crafted products.
              </p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants}>
            <div className="processGraphicBox graphicBox4">
              <h2>Design Approach</h2>
              <p>
                From an idea to the product launch. Creating solutions to
                important and unexpected problems through design.
              </p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants}>
            <div className="processGraphicBox graphicBox5">
              <h2>Launch</h2>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
